import React from 'react';
import SolutionInstallmentExaminationCompletedContainer from 'containers/SolutionInstallmentExaminationCompletedContainer/SolutionInstallmentExaminationCompletedContainer';

export default function SolutionInstallmentExaminationCompletedPage() {
    return (
        <SolutionInstallmentExaminationCompletedContainer />
    )
}
